import React, { createContext, useContext, useEffect, useState } from 'react'

import { FeatureFlags, fetchFeatureFlags } from '../service/featureService'

interface FeatureContextType {
    features: FeatureFlags
    isLoading: boolean
    isFeatureEnabled: (featureKey: string) => boolean
}

const defaultFeatures: FeatureFlags = {
    meta_integration: false
}

const FeatureContext = createContext<FeatureContextType>({
    features: defaultFeatures,
    isLoading: true,
    isFeatureEnabled: () => false
})

export function FeatureProvider({ children }: { children: React.ReactNode }) {
    const [features, setFeatures] = useState<FeatureFlags>(defaultFeatures)
    const [isLoading, setIsLoading] = useState(true)

    useEffect(() => {
        fetchFeatureFlags()
            .then(flags => {
                console.log('Feature flags loaded:', flags)
                setFeatures(flags)
                setIsLoading(false)
            })
            .catch((error) => {
                console.error('Failed to load feature flags:', error)
                setIsLoading(false)
            })
    }, [])

    const isFeatureEnabled = (featureKey: string): boolean => {
        return features[featureKey] ?? false
    }

    return (
        <FeatureContext.Provider value={{ features, isLoading, isFeatureEnabled }}>
            {children}
        </FeatureContext.Provider>
    )
}

export const useFeatures = () => useContext(FeatureContext)

export default FeatureContext
